module.exports = __webpack_public_path__ + "mer/fonts/iconfont.8fa86952.woff2";